"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingHistoryLegacyFetcher = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var ui_1 = require("../pages/BillingHistory/ui");
var legacy_mapper_1 = require("../utils/legacy-mapper");
var Data = function (_a) {
    var _b = __read(_a.data, 3), billablePeriods = _b[0], migratedStatements = _b[1], latestBillingPeriod = _b[2];
    var history = (0, legacy_mapper_1.mapBastResponseToBillingHistoryLegacy)(billablePeriods, migratedStatements);
    return (react_1.default.createElement(ui_1.BillingHistoryUI, { historyLegacy: history, latestBillingPeriod: latestBillingPeriod }));
};
var BillingHistoryLegacyFetcher = function (_a) {
    var accountId = _a.accountId;
    var billablePeriodsQueryResult = (0, legacy_queries_1.useBillablePeriodsLegacyQuery)(accountId);
    var migratedStatementsQueryResult = (0, legacy_queries_1.useMigratedStatementsLegacyQuery)(accountId);
    var billingQueryResult = (0, legacy_queries_1.useBillingLegacyQuery)(accountId, 'latest');
    return (react_1.default.createElement(ui_tools_1.QueryResultRenderer, { queryResults: [
            billablePeriodsQueryResult,
            migratedStatementsQueryResult,
            billingQueryResult,
        ], NoData: ui_1.Loading, Error: ui_1.Error, Data: Data }));
};
exports.BillingHistoryLegacyFetcher = BillingHistoryLegacyFetcher;
